/*eslint-disable*/
import React from "react";
import { Avatar } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Skeleton from "@mui/material/Skeleton";

interface User {
    first_name?: string;
    last_name?: string;
}

interface UserAvatarProps {
    user: User;
    size?: "sm" | "md" | "lg";
    color?: string;
}

const UserAvatar: React.FC<UserAvatarProps> = ({ user, size, color }) => {
    const theme = useTheme();

    // Generate initials
    const getInitials = () => {
        if (user?.first_name) {
            return `${user?.first_name.charAt(0)}${
                user?.last_name?.charAt(0) || ""
            }`;
        }
        return "N/A";
    };

    return (
        <Avatar
            sx={{
                width: size === "sm" ? 33 : size === "md" ? 45 : 60,
                height: size === "sm" ? 33 : size === "md" ? 45 : 60,
                bgcolor: color ? color : "#084347",
                fontSize: size === "sm" ? 12 : size === "md" ? 16 : 24,
                fontWeight: size === "sm" ? 400 : size === "md" ? 500 : 500,
                color: color ? "black" : "white",
            }}
        >
            {user?.first_name ? getInitials() : ""}
        </Avatar>
    );
};

export default UserAvatar;
